import * as React from 'react';
import { IconProps } from '../types';

const IcHalfTurn = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M14.148 23.116c-.062.466-.48.844-.95.861-2.7.17-5.45-.622-7.649-2.197A12.021 12.021 0 0 1 .98 15.377c-.84-2.845-.57-6.001.75-8.66A12.094 12.094 0 0 1 8.12.83c1.639-.64 3.426-.94 5.183-.793.762.075 1.134 1.11.61 1.665-.326.427-.904.342-1.373.313v19.96c.299-.005.603-.048.898.024.466.134.796.635.71 1.117ZM17.197 23.065c-.656.35-1.53-.215-1.467-.957-.004-.475.368-.843.797-.982.559-.198 1.117-.751 1.74-.446.68.255.816 1.247.266 1.7-.409.29-.88.479-1.336.685ZM21.108 20.259c-.6.283-1.367-.172-1.409-.834-.078-.502.333-.861.61-1.22.28-.336.521-.797 1-.866.554-.125 1.134.308 1.19.868.071.46-.261.835-.512 1.181-.259.318-.497.689-.879.87ZM23.508 15.947c-.496.253-1.165.015-1.38-.5-.193-.386-.01-.806.074-1.194.12-.425.117-.941.505-1.23.488-.43 1.328-.198 1.576.385.173.377.023.793-.044 1.177-.128.495-.198 1.128-.731 1.362ZM23.786 11.064c-.483.258-1.144.02-1.347-.488-.133-.363-.182-.749-.284-1.12-.115-.384-.15-.84.132-1.162.41-.548 1.367-.484 1.675.14.203.486.298 1.014.387 1.532.09.44-.16.91-.563 1.098ZM21.747 6.606c-.494.153-.974-.155-1.226-.566-.312-.479-.914-.879-.83-1.521.061-.753 1.06-1.156 1.636-.678.392.37.712.814 1.017 1.257.373.541.034 1.359-.597 1.508ZM18.084 3.335c-.441.131-.834-.167-1.217-.337-.393-.2-.912-.326-1.075-.793-.305-.68.314-1.555 1.07-1.416.59.175 1.173.436 1.674.798.613.5.315 1.595-.452 1.748Z"
    />
  </svg>
);

export default IcHalfTurn;
